const ReInvestmentPlanStatus = Object.freeze({
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
});

export default ReInvestmentPlanStatus;
